import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class SpinnerService {
    private showSpinner = new Subject<boolean>();
    getData(): Observable<boolean> {
        return this.showSpinner.asObservable();
    }
    activate() {
        this.showSpinner.next(true);
    }

    deactivate() {
        this.showSpinner.next(false);
    }
}
